module.exports = __webpack_public_path__ + "static/media/speedometer.9b962c02.svg";